---
de:
  navigation:
    error:
      no_company_selected: Kein Unternehmen ausgewählt
      too_many_power_plants_selected: Zu viele Kraftwerke ausgewählt
    language:
      de: Deutsch
      en: Englisch
      fr: Französisch
      nb: Norwegisch
      select: Sprache auswählen
    main_menu:
      admin_market_prices: Marktpreise
      admin_volumes: Volumen
      admin_weather: Wettervorhersagen
      api_access: API-Zugang
      api_docs: API-Dokumentation
      availability: Verfügbarkeitsanalyse
      availability_analysis: Verfügbarkeitsanalyse
      benchmarking: Benchmarking
      budget_forecasts: Budgetprognosen
      commercial_scada: Commercial SCADA
      community_access: Gemeinschaftszugang
      companies: Unternehmen
      components: Komponenten
      contracts: Contracts
      data_export: Datenexport
      elcert_and_goos: Elcert und GoOs
      elhub: Elhub
      fall_lease: Konzession
      feature_requests: Feature-Anfragen
      follow_up: Leistungsbeurteilung
      full_map: Vollständige Karte
      home: Startseite
      liquidity_planning: Liquiditätsplanung
      log_out: Abmelden
      map: Karte
      market_data: Preisdaten
      market_outlook: Terminmarktpreise
      market_prices: Historische Preise
      marketplace: Marktplatz
      more_information: Weitere Informationen
      nest: Nest
      news_items: Beiträge
      nve_plants: NVE-Anlagen
      o_and_m_dashboard_v1: O&M-Dashboard v1
      om_dashboard: Dashboard
      operations: Betrieb
      portfolio: Portfolio
      portfolio_stats: Portfoliostatistiken
      power_plants: Kraftwerke
      pp_info: Kraftwerksinformationen
      ppa_pricing: PPA-Preise
      production_scheduling: Prod. Planung
      production_simulation_plan: Produktions-Simulationsplan
      profile: Profil
      public_kiosk_mode: Öffentlicher Kiosk-Modus
      responsibles: Verantwortliche
      root: Stamm
      subsidiaries: Tochtergesellschaften
      suppliers: Lieferanten
      task_management: Aufgabenverwaltung
      users: Benutzer
      white_labeling: White Labeling
    production_simulation_plan_query: Produktions-Simulationsabfrage ausführen
